function LotStateFilter(statuses) {
	this.statuses = Array.isArray(statuses) ? statuses : [];
}

/**
 * @param function
 * @return Node
 */
LotStateFilter.prototype.createHtml = function(changeStatusHandler) {
	if (typeof changeStatusHandler !== 'function') {
		return;
	}

	const containerElement = document.createElement('div');
	containerElement.setAttribute('class', 'lot-state-filter-container');

	const ulElement = document.createElement('ul');
	ulElement.classList.add('lot-state-filter-item-container');

	this.statuses.forEach(status => {
		const liElement = document.createElement('li');
		liElement.classList.add('lot-state-filter-state');
		liElement.classList.add('is-status-' + status.status.value);

		const buttonElement = document.createElement('button');
		buttonElement.setAttribute('data-status', status.status.value);
		buttonElement.classList.add('lot-state-filter-state-button');

		if (status.isActive) {
			buttonElement.classList.add('is-active');
		}

		buttonElement.addEventListener('click', function() {
			this.classList.toggle('is-active');
			changeStatusHandler(this.getAttribute('data-status'));
		});

		const labelElement = document.createElement('span');

		labelElement.setAttribute('class', 'legenda-status-label');
		labelElement.appendChild(document.createTextNode(status.status.label));
		buttonElement.appendChild(labelElement);

		liElement.appendChild(buttonElement);

		ulElement.appendChild(liElement);
	});

	containerElement.appendChild(ulElement);

	return containerElement;
};

export default LotStateFilter;